const emailTextFieldLabel = {
  id: 'accountProfile.emailTextFieldLabel',
};
const generalInformationTitle = {
  id: 'accountProfile.generalInformationTitle',
};
const idTextFieldLabel = {
  id: 'accountProfile.idTextFieldLabel',
};
const nameTextFieldLabel = {
  id: 'accountProfile.nameTextFieldLabel',
};

const storesTitle = {
  id: 'accountProfile.storesTitle',
};
const storesRecordatoryText = {
  id: 'accountProfile.storesRecordatoryText',
};

const textIds = {
  emailTextFieldLabel,
  generalInformationTitle,
  idTextFieldLabel,
  nameTextFieldLabel,
  storesTitle,
  storesRecordatoryText,
};

export default textIds;
